module.exports = __webpack_public_path__ + "static/SohneVF-web-e46484be8975acc1190931dbf60338e7.woff2";